export default {
  namespaced: true,
  state: {
    type: null,
    show: false,
    title: null,
    text: null,
    html: null
  },
  mutations: {
    show (state, payload) {
      state.show = true
      state.type = payload.type
      state.title = payload.title
      state.text = payload.text
      state.html = payload.html
    },
    hide (state) {
      state.show = false
    }
  },
  getters: {
    state: state => state
  },
  actions: {

  }
}
